import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders, HttpXsrfTokenExtractor } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppServiceService } from 'src/app/app-service.service';
import { environment } from 'src/environments/environment';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private router: Router, protected readonly keycloak: KeycloakService, private appService: AppServiceService, private tokenExtractor: HttpXsrfTokenExtractor) { }

    private actions: string[] = ["POST", "PUT", "DELETE"];
    private forbiddenActions: string[] = ["HEAD", "OPTIONS"];

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = this.appService.getUserToken(); // localStorage.getItem('token');

        if (token) {
            req = req.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`
                }
            });
        }

        let xsrfToken = this.tokenExtractor.getToken();
        var cToken = this.getCookieValue("ASP-XSRF-TOKEN");
        let permitted = this.findByActionName(req.method, this.actions);
        let forbidden = this.findByActionName(req.method, this.forbiddenActions);;

        if (req.url.includes(environment.BASE_URL)) {
            req = req.clone({
                withCredentials: true
            });
        }

        if (permitted !== undefined && forbidden === undefined && xsrfToken !== null) {
            req = req.clone({ setHeaders: { "X-XSRF-TOKEN": xsrfToken } });
            req = req.clone({ setHeaders: { "ASP-XSRF-TOKEN": cToken } });

        }
        return next.handle(req)
            .pipe(
                catchError((err, caught) => {
                    if (err.status === 401) {
                        localStorage.removeItem('token');
                        sessionStorage.removeItem("userResponse")
                        sessionStorage.removeItem("selectedEquipmentResponse");
                        this.keycloak.logout();
                        return of(err);
                    }
                    throw err;
                })
            );
    }

    private findByActionName(name: string, actions: string[]): string {
        return actions.find(action => action.toLocaleLowerCase() === name.toLocaleLowerCase());
    }

    private getCookieValue(cookieName: string) {
        const allCookies = decodeURIComponent(document.cookie).split("; ");
        for (let i = 0; i < allCookies.length; i++) {
            const cookie = allCookies[i];
            if (cookie.startsWith(cookieName + "=")) {
                return cookie.substring(cookieName.length + 1);
            }
        }
        return "";
    }
}
